import { defineMessages } from "react-intl";
const messages = defineMessages({
    selectOrganization: {
        id: "app.multiple.organization.selector.text",
        defaultMessage: "Organization",
    },
    selectOrganizationPlaceholder: {
        id: "app.multiple.organization.selector.placeholder.text",
        defaultMessage: "Select specific organizations",
    },
    selectAll: {
        id: "app.multiple.organization.selector.select.all.text",
        defaultMessage: "Select All",
    },
    clearSelection: {
        id: "app.multiple.organization.selector.clear.selection.text",
        defaultMessage: "Clear selection",
    },
});
export default messages;
